import React, { use, useEffect, useState } from 'react'
import { Table, Select, Input, Row, Col, Typography, Cascader } from 'antd'
import Card from '../Card'
import dayjs from 'dayjs'
import { reportOperational } from '../../services/dashboard-service'
import {
  projectSearch,
  getListStaff,
  addressSearch
} from '../../services/postservice'
import { OPTIONS_LABEL_DASHBOARD, realEstateOptions } from '../../configData'
import openNotification from '../common/Notification/openNotification '
import { removeVietnameseTones } from '../../config-func'

const { Title } = Typography
const { Option, OptGroup } = Select

const ProjectReport = ({ deId, startDate, endDate }) => {
  // Cột của bảng
  const columns = [
    {
      title: '#',
      dataIndex: 'key',
      key: 'key',
      fixed: 'left',
    },
    {
      title: 'Tên dự án',
      dataIndex: 'name',
      key: 'name',
      fixed: 'left',
    },
    {
      title: 'Tổng',
      dataIndex: 'total',
      key: 'total'
    },
    {
      title: 'Mới',
      dataIndex: 'new',
      key: 'new'
    },
    {
      title: 'Hoàn hảo',
      dataIndex: 'prefect',
      key: 'prefect'
    },
    {
      title: 'Phương án',
      dataIndex: 'option',
      key: 'option'
    },
    {
      title: 'Tạm dừng',
      dataIndex: 'paused',
      key: 'paused'
    },
    {
      title: 'Đã chốt',
      dataIndex: 'closed',
      key: 'closed'
    },
    {
      title: 'Loại',
      dataIndex: 'remote',
      key: 'remote'
    },
    {
      title: 'Trùng tin',
      dataIndex: 'duplicate',
      key: 'duplicate'
    },
    {
      title: 'Tỉnh/TP',
      dataIndex: 'city_name',
      key: 'city_name'
    },
    {
      title: 'Quận/huyện',
      dataIndex: 'district_name',
      key: 'district_name'
    },
    {
      title: 'Phường/ xã',
      dataIndex: 'town_name',
      key: 'town_name'
    }
  ]

  const [loadingTable, setLoadingTable] = useState(false)
  const [total, setTotal] = useState(0)
  const [dataSource, setDataSource] = useState([])
  const [listUser, setListUser] = useState([])
  const [listProject, setListProject] = useState([])
  const [filters, setFilters] = useState({
    // startDate: dayjs().startOf('year').unix(),
    // endDate: dayjs().endOf('year').unix()
  })

  async function fetchData() {
    setLoadingTable(true)
    let _dataSource = []

    const params = {
      ...filters,
      label: filters.lable || '',
      department_id: deId || '',
      user_id: filters.user_id || '',
      pageSize: 1000,
      start_date: startDate,
      end_date: endDate
      // start_date: filters.startDate,
      // end_date: filters.endDate
    }

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await reportOperational(cleanedData)
      const values = response?.data?.list
      _dataSource = values.map((item, index) => ({ ...item, key: index + 1 }))

      // }
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingTable(false)
      setDataSource(_dataSource)
    }
  }

  // Danh sách tài khoản theo SÀN
  const getUserAll = async () => {
    let page = 1
    let pageSize = 1000
    // const deId = localStorage.getItem('department_id')
    try {
      const body = {
        page,
        pageSize
        // department_id: deId
      }
      const res = await getListStaff(body) // Assuming roleSearch is an API function

      if (res && res?.data?.list) {
        const result = res?.data?.list.map((item) => ({
          ...item,
          value: item.id,
          label: item.name
        }))
        setListUser(result) // Update the state with the list of roles
      } else {
        // Handle the case where the response is unexpected or empty
        console.error('No data found or invalid response')
        setListUser([]) // Optionally, reset the list to an empty array
      }
    } catch (err) {
      // Handle the error gracefully
      console.error('Error fetching roles:', err)
      // You might want to show a notification or alert to the user here
      setListUser([]) // Optionally, reset the list to an empty array
    }
  }

  // Danh sách dự án
  const getProjectAll = async (values) => {
    let { page = 1, pageSize = 100 } = values || {}
    try {
      const body = { page, pageSize }
      const res = await projectSearch(body)
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.id,
        label: item.project_name
      }))

      setListProject(result)
    } catch (err) {}
  }

  useEffect(() => {
    if (deId) {
      fetchData()
    }
  }, [
    deId,
    startDate,
    endDate,
    filters.user_id,
    filters.project_id,
    filters.type_real_estate,
    filters.lable,
    filters.city_code
  ])

  useEffect(() => {
    getProjectAll()
    getUserAll()
  }, [])

  const filter = (inputValue, path) =>
    path.some((option) =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    )

  // const getListCities = async () => {
  //   try {
  //     const res = await addressSearch('', 'district')
  //     const result = res?.data?.list.map((item) => ({
  //       ...item
  //       // value: item.code,
  //       // label: item.name
  //     }))
  //     console.log('result', result)
  //     // setCities(result)
  //   } catch (err) {}
  // }

  // useEffect(() => {
  //   getListCities()
  // }, [])

  // Gọi API để lấy danh sách tỉnh/thành phố

  // const [loading, setLoading] = useState(false)
  const [options, setOptions] = useState([])
  const [cascaderValue, setCascaderValue] = useState([])
  const [isCascaderOpen, setIsCascaderOpen] = useState(false)
  const fetchCities = async () => {
    try {
      const response = await addressSearch('', 'city') // API trả về danh sách tỉnh
      const cities = response?.data?.list.map((city) => ({
        value: city.code,
        label: city.name,
        isLeaf: false // Không phải leaf vì cần load quận/huyện
      }))
      setOptions(cities)
    } catch (error) {
      console.error('Lỗi khi lấy danh sách tỉnh/thành phố:', error)
    }
  }

  // Gọi API để lấy danh sách quận/huyện hoặc phường/xã
  const loadData = async (selectedOptions) => {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    targetOption.loading = true
    // setLoading(true)
    try {
      let response
      const params = {
        parent_code: targetOption.value
      }
      if (selectedOptions.length === 1) {
        // Nếu chọn Tỉnh -> Gọi API lấy danh sách Quận/Huyện
        // response = await axios.get(
        //   `/api/districts?city_code=${targetOption.value}`
        // )

        response = await addressSearch(params, 'district')
      } else if (selectedOptions.length === 2) {
        // Nếu chọn Quận/Huyện -> Gọi API lấy danh sách Phường/Xã
        response = await addressSearch(params, 'town')
      }

      targetOption.loading = false
      targetOption.children = response?.data?.list.map((item) => ({
        value: item.code,
        label: item.name,
        isLeaf: selectedOptions.length === 2 // Phường/Xã là leaf cuối
      }))

      setOptions((prev) => [...prev]) // Cập nhật lại danh sách
    } catch (error) {
      openNotification('error', error?.message || 'Có lỗi xảy ra')
      console.error('Lỗi khi lấy danh sách:', error)
    } finally {
      // setLoading(false)
    }
  }
  useEffect(() => {
    fetchCities() // Gọi API lấy danh sách tỉnh/thành phố
  }, [])

  const ensureNextLevelLoaded = (selectedOptions) => {
    if (!selectedOptions?.length) return
    const last = selectedOptions[selectedOptions.length - 1]
    if (!last?.children && !last?.isLeaf) {
      loadData(selectedOptions)
    }
  }

  return (
    <div style={{ marginTop: 30 }}>
      <Title level={4}>
        Báo cáo thông tin dự án theo hiện trạng và khu vực
      </Title>
      <Card>
        {/* Bộ lọc */}
        <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
          <Col span={4}>
            <span>Nhu cầu</span>
            <Select
              defaultValue=""
              onChange={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  lable: e
                }))
              }}
              style={{ width: '100%' }}
              showSearch={true}
              allowClear={true}
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
            >
              <Select.Option value="">Tất cả</Select.Option>
              {OPTIONS_LABEL_DASHBOARD.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={4}>
            <span>Người đăng tin</span>
            <Select
              defaultValue=""
              onChange={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  user_id: e
                }))
              }}
              style={{ width: '100%' }}
              showSearch={true}
              allowClear={true}
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
            >
              <Select.Option value="">Tất cả</Select.Option>
              {listUser.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={8}>
            <span>Tỉnh/Thành phố</span>
            <Cascader
              options={options}
              loadData={loadData} // Gọi API khi chọn
              value={cascaderValue}
              onDropdownVisibleChange={(open) => {
                setIsCascaderOpen(open)
              }}
              onChange={(value, selectedOptions) => {
                setCascaderValue(value || [])
                setFilters((prev) => ({
                  ...prev,
                  city_code: value?.[0],
                  district_code: value?.[1],
                  town_code: value?.[2]
                }))
                ensureNextLevelLoaded(selectedOptions)
                setIsCascaderOpen((value?.length || 0) < 3)
              }}
              placeholder="Chọn tỉnh/thành → quận/huyện → phường/xã"
              style={{ width: '100%' }}
              showSearch={{ filter }}
              changeOnSelect
              open={isCascaderOpen}
            />
            {/* <Select value={filters.khuVuc} style={{ width: '100%' }}>
              <Option value="Tất cả">Khu vực</Option>
            </Select> */}
          </Col>
          <Col span={4}>
            <span>Loại BĐS</span>
            {/* <Select value={filters.loaiBDS} style={{ width: '100%' }}>
              <Option value="Tất cả">Loại BĐS</Option>
            </Select> */}
            {/* <Select
              placeholder="Chọn loại BĐS"
              style={{ width: '100%' }}
              allowClear
            >
              <Option value={null}>Tất cả</Option>
              {realEstateOptions.map((group) => (
                <OptGroup key={group.value} label={group.label}>

                  {group.children.map((child) => (
                    <Option key={child.value} value={child.value}>
                      {child.label}
                    </Option>
                  ))}
                </OptGroup>
              ))}
            </Select> */}

            <Cascader
              options={realEstateOptions}
              placeholder="Chọn loại BĐS"
              // onChange={onChangeBDS}
              onChange={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  type_real_estate: e?.[1]
                }))
              }}
              changeOnSelect
              showSearch={{ filter }}
              style={{ width: '100%' }}
            />
          </Col>
          <Col span={4}>
            <span>Tên dự án</span>
            <Select
              defaultValue=""
              onChange={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  project_id: e
                }))
              }}
              style={{ width: '100%' }}
              showSearch={true}
              allowClear={true}
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
            >
              <Select.Option value="">Tất cả</Select.Option>
              {listProject?.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>

        {/* Bảng dữ liệu */}
        <Table
          loading={loadingTable}
          columns={columns}
          scroll={{
            x: dataSource?.list?.length > 0 ? 'max-content' : '100%',
            y: 'calc(100vh - 400px)'
          }}
          dataSource={dataSource}
          pagination={{
            total: dataSource.total,
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
          }}
        />
      </Card>
    </div>
  )
}

export default ProjectReport
